"use client";

import { c as _c } from "react/compiler-runtime";
import { useBusinessVariables } from "@grupa-pracuj/business-variables";
import { CookieAgreements, type CookieTrackerEventHandler, configureTcfManager, getConfig as getCookiesConfig } from "@grupa-pracuj/cookies-library-sip";
import { Footer, getConfig as getFooterConfig } from "@grupa-pracuj/footer-library-sip";
import { useGatewayContext } from "@grupa-pracuj/gateway-library-sip";
import { getConfig as getHeaderConfig, Header } from "@grupa-pracuj/header-library-sip";
import { useSearchParams } from "next/navigation";
import { type ComponentProps, type ReactNode, useEffect, useState } from "react";
import { useTracker } from "@/tracker";
import styles from "./HomeContent.module.css";
type User = ComponentProps<typeof Header>["user"];
configureTcfManager({
  cmpId: Number(process.env.NEXT_PUBLIC_TCF_CMP_ID),
  cmpVersion: Number(process.env.NEXT_PUBLIC_TCF_CMP_VERSION),
  cookieDomain: process.env.COOKIE_DOMAIN ?? "",
  vendorListUrl: process.env.NEXT_PUBLIC_GVL_VENDOR_LIST_URL ?? "",
  purposesUrl: process.env.NEXT_PUBLIC_GVL_PURPOSES_URL ?? ""
});
const HomeContent = t0 => {
  const $ = _c(37);
  const {
    children,
    user
  } = t0;
  const http = useGatewayContext();
  const searchParams = useSearchParams();
  const businessVariables = useBusinessVariables();
  const [forceOpenCookieAgreement, setForceOpenCookieAgreement] = useState(false);
  const {
    analyticsInstance,
    sendBaseAnalytics,
    sendCookieAgreementsModal
  } = useTracker();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("year") ?? "";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const year = t1;
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams.get("month") ?? "";
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const month = t2;
  let t3;
  if ($[4] !== searchParams) {
    t3 = searchParams.get("pageNumber") ?? "";
    $[4] = searchParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const pageNumber = t3;
  const routeChangeKey = `${year}-${month}-${pageNumber}`;
  let t4;
  let t5;
  if ($[6] !== routeChangeKey || $[7] !== sendBaseAnalytics) {
    t4 = () => {
      const trackBaseAnalytics = async _routeKey => {
        await sendBaseAnalytics();
      };
      trackBaseAnalytics(routeChangeKey).catch(_temp);
    };
    t5 = [sendBaseAnalytics, routeChangeKey];
    $[6] = routeChangeKey;
    $[7] = sendBaseAnalytics;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== sendCookieAgreementsModal) {
    t6 = async data => {
      await sendCookieAgreementsModal(data);
    };
    $[10] = sendCookieAgreementsModal;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleCookieTrackerEvent = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getHeaderConfig({
      attachProviders: true
    });
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== analyticsInstance || $[14] !== businessVariables || $[15] !== http || $[16] !== user) {
    t8 = <Header businessVariables={businessVariables} http={http} analytics={analyticsInstance} config={t7} user={user} />;
    $[13] = analyticsInstance;
    $[14] = businessVariables;
    $[15] = http;
    $[16] = user;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== children) {
    t9 = <main className={styles.main}>{children}</main>;
    $[18] = children;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setForceOpenCookieAgreement(false);
    };
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== forceOpenCookieAgreement || $[22] !== handleCookieTrackerEvent) {
    t11 = getCookiesConfig({
      attachProviders: true,
      forceOpen: forceOpenCookieAgreement,
      reloadOnSave: false,
      onSubmit: t10,
      onCookieTrackerEvent: handleCookieTrackerEvent
    });
    $[21] = forceOpenCookieAgreement;
    $[22] = handleCookieTrackerEvent;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== businessVariables || $[25] !== http || $[26] !== t11) {
    t12 = <CookieAgreements businessVariables={businessVariables} http={http} config={t11} />;
    $[24] = businessVariables;
    $[25] = http;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = getFooterConfig({
      attachProviders: true,
      handleAgreements: () => {
        setForceOpenCookieAgreement(true);
      }
    });
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== analyticsInstance || $[30] !== businessVariables) {
    t14 = <Footer config={t13} businessVariables={businessVariables} analytics={analyticsInstance} />;
    $[29] = analyticsInstance;
    $[30] = businessVariables;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t12 || $[33] !== t14 || $[34] !== t8 || $[35] !== t9) {
    t15 = <>{t8}{t9}{t12}{t14}</>;
    $[32] = t12;
    $[33] = t14;
    $[34] = t8;
    $[35] = t9;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
export default HomeContent;
function _temp() {}